/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Status_StoppedInputs */

const vi_tea_machines_status_stopped = /** @type {(inputs: Tea_Machines_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã dừng`)
};

/**

* @param {Tea_Machines_Status_StoppedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_status_stopped = /** @type {((inputs?: Tea_Machines_Status_StoppedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Status_StoppedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_status_stopped(inputs)
});